import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

export enum BUSINESS_LINES {
    GIFTING = "GIFTING",
    INSTAMART = "INSTAMART",
    FOOD = "FOOD",
}

export interface CouponTimerPayload {
    isTimer: boolean;
    timerValue: string;
}

export enum COUPON_GROUP_TYPES {
    MORE_OFFERS = "COUPON_SECTION_TYPE_MORE_OFFERS",
    PAYMENT_OFFERS = "COUPON_SECTION_TYPE_PAYMENT_OFFERS",
    BEST_COUPON = "COUPON_SECTION_TYPE_BEST_COUPONS",
    GREAT_DEALS = "COUPON_SECTION_TYPE_GREAT_DEALS",
    APPLIED_OFFERS = "COUPON_SECTION_TYPE_APPLIED_OFFERS",
    RECOMMENDED_OFFERS = "COUPON_SECTION_TYPE_RECOMMENDED_OFFERS",
}

export interface CouponCardImpressionPayload {
    offerId?: string;
    isApplicable?: boolean;
    couponCode?: string;
    couponName?: string;
    timerPayload?: CouponTimerPayload;
    couponType?: string;
    section?: string;
    description?: string;
    type?: COUPON_GROUP_TYPES;
    isSelected?: boolean;
    isApplied?: boolean;
    applicabletype?: BUSINESS_LINES;
}

export interface RibbonUIMetaData {
    asset: {
        icon: string;
        height: number;
        width: number;
    };
    backgroundColor: string;
    textColor: keyof IColors;
}

export enum CouponTagIdentifiers {
    IPL_SUPER_SIX_OFFER = "SUPER_SIX_OFFER",
}

export interface IAppliedCouponCodes {
    businessLine: string;
    code: string;
}
